// extracted by mini-css-extract-plugin
export default {"pageBanner":"PageBanner_pageBanner__dDTW-"};